import { render, staticRenderFns } from "./docpack.vue?vue&type=template&id=287fee78&scoped=true&"
import script from "./docpack.vue?vue&type=script&lang=js&"
export * from "./docpack.vue?vue&type=script&lang=js&"
import style0 from "./docpack.vue?vue&type=style&index=0&id=287fee78&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "287fee78",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
installComponents(component, {VCard,VDialog,VIcon,VListItem,VListItemContent})
